import { Formik } from 'formik';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { type GiftVoucherDataFragment } from '../../../api/fragments';
import Form from '../../../components/fields/Form';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import { getInitialValues } from '../../../utilities/kycPresets';
import useAgreementsValues from '../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';
import Inner from './Inner';

type GiftVoucherFormProps = {
    voucher: GiftVoucherDataFragment;
};

const GiftVoucherForm = ({ voucher }: GiftVoucherFormProps) => {
    const { t } = useTranslation('giftVoucherDetails');

    const navigate = useNavigate();
    const agreements = useAgreementsValues(voucher.purchaserAgreements);

    const initialValues = useMemo(
        () => ({
            purchaserData: {
                ...voucher.purchaser,
                fields: getInitialValues(voucher.purchaser.fields, voucher.purchaserKYC),
            },
            purchaserAgreementsData: agreements,
        }),
        [voucher.purchaser, voucher.purchaserKYC, agreements]
    );

    return (
        <Formik initialValues={initialValues} onSubmit={null} validate={null}>
            {({ handleSubmit }) => (
                <ConsolePageWithHeader
                    onBack={() => navigate('/admin/giftCodes')}
                    title={t('giftVoucherDetails:title', { name: voucher.giftCode })}
                >
                    <Form id="giftVoucherUpdate" name="giftVoucherUpdate" onSubmitCapture={handleSubmit}>
                        <Inner voucher={voucher} />
                    </Form>
                </ConsolePageWithHeader>
            )}
        </Formik>
    );
};

export default GiftVoucherForm;
